import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Help from '../help/Help';
import Error from '../error/Error';

var getId = function getId() {
  return Math.random().toString(36).substring(7);
};

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, props);
    _this.id = props.id || "tds-checkbox-".concat(getId());
    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isDark = _this$props.isDark,
          className = _this$props.className,
          size = _this$props.size,
          isRadio = _this$props.isRadio,
          name = _this$props.name,
          value = _this$props.value,
          caption = _this$props.caption,
          checked = _this$props.checked,
          defaultChecked = _this$props.defaultChecked,
          _onChange = _this$props.onChange,
          _onBlur = _this$props.onBlur,
          disabled = _this$props.disabled,
          error = _this$props.error,
          helpText = _this$props.helpText,
          forceForProp = _this$props.forceForProp,
          showLabel = _this$props.showLabel;
      var additionalClass = className ? " ".concat(className) : '';
      var checkboxClasses = classNames("tds-checkbox tds-checkbox--".concat(size, " ").concat(additionalClass), {
        'tds-checkbox--dark': isDark,
        'tds-checkbox--disabled': disabled
      });
      var labelClasses = classNames('tds-checkbox__label', {
        'tds-checkbox__label--show-label': showLabel
      });
      var labelTextClasses = showLabel ? 'tds-checkbox__label-text' : 'sr-only';
      var forProp = forceForProp ? {
        "for": this.id
      } : {
        htmlFor: this.id
      };
      /* eslint-disable jsx-a11y/label-has-associated-control */

      /* eslint-disable jsx-a11y/label-has-for */

      var checkboxElement = /*#__PURE__*/React.createElement("div", {
        className: checkboxClasses
      }, /*#__PURE__*/React.createElement("input", {
        id: this.id,
        type: isRadio ? 'radio' : 'checkbox',
        name: name,
        value: value,
        checked: checked,
        disabled: disabled,
        defaultChecked: defaultChecked,
        onChange: function onChange(evt) {
          return !disabled && _onChange(evt);
        },
        onBlur: function onBlur(evt) {
          return !disabled && _onBlur(evt);
        },
        className: "tds-checkbox__input"
      }), /*#__PURE__*/React.createElement("label", _extends({
        className: labelClasses
      }, forProp), /*#__PURE__*/React.createElement("span", {
        className: labelTextClasses
      }, caption)));
      return helpText || error ? /*#__PURE__*/React.createElement("div", null, helpText ? /*#__PURE__*/React.createElement(Help, null, helpText) : null, checkboxElement, error ? /*#__PURE__*/React.createElement(Error, {
        error: error
      }) : null) : checkboxElement;
    }
  }]);

  return Checkbox;
}(React.Component);

Checkbox.displayName = "Checkbox";
export { Checkbox as default };
Checkbox.propTypes = {
  error: PropTypes.node,
  helpText: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.string,
  isDark: PropTypes.bool,
  className: PropTypes.string,
  isRadio: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  forceForProp: PropTypes.bool,
  name: PropTypes.string,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
Checkbox.defaultProps = {
  id: undefined,
  size: 'md',
  className: '',
  isDark: false,
  isRadio: false,
  name: '',
  checked: undefined,
  defaultChecked: undefined,
  value: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  caption: '',
  disabled: false,
  showLabel: false,
  error: '',
  helpText: '',
  forceForProp: false
};